import { render } from "./Contact-Customer.vue?vue&type=template&id=b83ae4b6&scoped=true"
import script from "./Contact-Customer.vue?vue&type=script&lang=js"
export * from "./Contact-Customer.vue?vue&type=script&lang=js"

import "./Contact-Customer.vue?vue&type=style&index=0&id=b83ae4b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b83ae4b6"]])

export default __exports__